var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editor-container" }, [
    _c("div", { staticClass: "editor-header" }, [
      _c("span", { staticClass: "file-type" }),
      _c(
        "div",
        { staticClass: "header-buttons" },
        [
          !_vm.isRevision
            ? _c(
                "el-button",
                {
                  attrs: { type: "text", icon: "el-icon-edit" },
                  on: { click: _vm.toggleEditMode }
                },
                [_vm._v(_vm._s(_vm.isEditMode ? "只读" : "编辑"))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: "text", icon: "el-icon-document-copy" },
              on: { click: _vm.copyCode }
            },
            [_vm._v("Copy")]
          )
        ],
        1
      )
    ]),
    _c("div", { ref: "editorWrapper", staticClass: "editor-wrapper" }, [
      _c("pre", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isEditMode,
            expression: "!isEditMode"
          }
        ],
        staticClass: "code-display",
        domProps: { innerHTML: _vm._s(_vm.highlightedCode) }
      }),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isEditMode,
            expression: "isEditMode"
          },
          {
            name: "model",
            rawName: "v-model",
            value: _vm.codeExample,
            expression: "codeExample"
          }
        ],
        ref: "editor",
        staticClass: "code-editor",
        attrs: { spellcheck: "false" },
        domProps: { value: _vm.codeExample },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.codeExample = $event.target.value
            },
            _vm.updateHighlight
          ],
          scroll: _vm.syncScroll
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }